export abstract class LFATokenService {
  static async fetchLFAToken(getLFAToken: () => Promise<string>) {
    if (!getLFAToken) {
      throw new Error('LFA getLFAToken is required');
    }
    const token = await getLFAToken();
    if (!token) {
      throw new Error('LFA auth Token is required');
    }

    return token;
  }
}
